import { Component, OnInit, SimpleChanges, OnChanges, Input, ViewChild } from '@angular/core';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { AbstractControl, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { TeamAbsenceService } from 'src/app/_services/dispo/team-absence.service';
import { CustomerService } from 'src/app/_services/cinema/customer.service';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { PerfectScrollbarComponent,PerfectScrollbarConfig, PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort, MatSortModule} from '@angular/material/sort';
import { LiveAnnouncer} from '@angular/cdk/a11y';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'app-team-absences',
  templateUrl: './team-absences.component.html',
  styleUrls: ['./team-absences.component.css']
})
export class TeamAbsencesComponent implements OnInit {
  content: any;
  orderData: any;
  teamForm: any;
  orderList: any;
  absencesList: any;
  isNew: Boolean = false;
  addNew: Boolean = false;
  customer_id: any;
  submitted = false;
  teamBaseData: any;

  defaultTimes = [
    { day: 0, default_start: 7.00, default_end: 16.00, hours: 9, active: true, note: '' },
    { day: 1, default_start: 7.00, default_end: 16.00, hours: 9, active: true, note: '' },
    { day: 2, default_start: 7.00, default_end: 16.00, hours: 9, active: true, note: '' },
    { day: 3, default_start: 7.00, default_end: 16.00, hours: 9, active: true, note: '' },
    { day: 4, default_start: 7.00, default_end: 12.00, hours: 5, active: true, note: '' },
    { day: 5, default_start: null, default_end: null, hours: 0, active: false, note: '' },
    { day: 6, default_start: null, default_end: null, hours: 0, active: false, note: '' }
  ];

   // Funktion zum Anzeigen des Wochentagsnamens
   getDayName(dayIndex: number): string {
    const days = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
    return days[dayIndex];
  }

  displayedColumns: string[] = ['created_at','user','absence_type','start_date', 'end_date','days','note'];
  dataSource: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild( MatPaginator ) paginator: MatPaginator;

  public configPS: PerfectScrollbarConfigInterface = { wheelPropagation: true }; @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent; directiveRef?: PerfectScrollbarDirective;

  constructor(
    private orderService: OrderService,
    private customerBranchService: CustomerBranchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private teamBaseService: TeamBaseService,
    private teamAbsenceService: TeamAbsenceService,
    private customerService: CustomerService,
    private _liveAnnouncer: LiveAnnouncer,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
     //get current movie data

    this.fetchData();
  }

  fetchAbsence() {
    console.log(this.teamBaseData);
    this.teamAbsenceService.getAllByTeamBaseId(this.teamBaseData.teamBase.id).subscribe( data => {
      this.absencesList = data;
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    },
    err => { this.content = JSON.parse(err.error).message;}
  );

  }

  addAbsence() {
    this.router.navigate(['./' + 'neu' + '/team-absence-base'],{ relativeTo: this.route });
  }

  gotoAbsenceDetails(row) {   
    this.router.navigate(['./' + row.id + '/team-absence-base'],{ relativeTo: this.route });
  }

  calculateDays(startDate: string, endDate: string): number {
    const start = moment(startDate);
    const end = moment(endDate);
    return end.diff(start, 'days') + 1; // Add 1 to include the end date
  }

  getWeekdayInGerman(date: string): string {
    const weekday = moment(date).format('dddd'); // Get the weekday in English
    
    const weekdayTranslations = {
      'Monday': 'Montag',
      'Tuesday': 'Dienstag',
      'Wednesday': 'Mittwoch',
      'Thursday': 'Donnerstag',
      'Friday': 'Freitag',
      'Saturday': 'Samstag',
      'Sunday': 'Sonntag'
    };

    return weekdayTranslations[weekday] || weekday; // Return translated or original if not found
  }

  delete() {
    this.teamAbsenceService.delete(1).subscribe(
      data => {
        this.toastr.success('Eintrag wurde unwiderruflich gelöscht', 'Eintrag gelöscht!');
      },
      err => {
        this.content = JSON.parse(err.error).message;
      }
    );
  }


  onRouterOutletActivate(event) {
    this.fetchData();
   }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  editDefaultWorkingTimes() {
    this.router.navigate(['./default-working-times'],{ relativeTo: this.route });
  }

  fetchData() {
    this.teamBaseService.getCurrentObject().subscribe( data => {
      this.teamBaseData = data;
      this.defaultTimes = data.teamBase.default_working_times;
      this.fetchAbsence();
    },
    err => { this.content = JSON.parse(err.error).message;}
  );
  }





}
